/**
 * 状态标签（语义色胶囊）
 * 支持订单 / 经纪 / 竞价 / 牛只 / 挂牌 / 交易方式 / 在途 各状态机字典
 */
import {
  AUCTION_STATUS,
  BROKER_ORDER_STATUS,
  CATTLE_STATUS,
  LISTING_STATUS,
  ORDER_STATUS,
  SALE_STATUS,
  TRADE_MODE,
  TRANSIT_STATUS,
  type StatusMeta,
} from '@/utils/constants';

export type StatusTagType =
  | 'order'
  | 'broker'
  | 'auction'
  | 'cattle'
  | 'sale'
  | 'listing'
  | 'trade'
  | 'transit'
  | 'custom';

interface StatusTagProps {
  type?: StatusTagType;
  status?: number;
  label?: string;
  tone?: StatusMeta['tone'];
  className?: string;
}

const DICTS: Record<Exclude<StatusTagType, 'custom'>, Record<number, StatusMeta>> = {
  order: ORDER_STATUS,
  broker: BROKER_ORDER_STATUS,
  auction: AUCTION_STATUS,
  cattle: CATTLE_STATUS,
  sale: SALE_STATUS,
  listing: LISTING_STATUS,
  trade: TRADE_MODE,
  transit: TRANSIT_STATUS,
};

export default function StatusTag({ type = 'custom', status, label, tone, className }: StatusTagProps) {
  let resolvedLabel = label;
  let resolvedTone: StatusMeta['tone'] = tone ?? 'default';

  if (type !== 'custom' && status !== undefined) {
    const meta = DICTS[type][status];
    if (meta) {
      resolvedLabel = meta.label;
      resolvedTone = meta.tone;
    }
  }

  if (!resolvedLabel) return null;

  const cls = ['status-tag', resolvedTone ? `status-tag--${resolvedTone}` : '', className ?? '']
    .filter(Boolean)
    .join(' ');

  return <span className={cls}>{resolvedLabel}</span>;
}
